import React from 'react';
import { connect } from 'react-redux';

import { Table } from 'reactstrap';
import '../CalculateInstallationData/styles.scss';
import {standardList} from "../../../../app.values";

import { prepareNum, unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';
import { APP_TEXTS } from '../../../../texts/texts';

const CalculateInstallationData = props => ( // eslint-disable-line
  <div className="calculation">
    <section className="list-type calculate-installation-data">
      {props.isAS3600 && (
        <Table bordered size="sm">
          <tbody>
          <tr>
            <th scope="row">{APP_TEXTS.REBAR_DESIGN_DEVELOPMENT_LENGTH.Content}</th>
            <td colSpan="2">
              {prepareNum(props.data.Lbd, true)}
            </td>
          </tr>
          <tr>
            <th scope="row">{APP_TEXTS.REBAR_DESIGN_NUMBER_REBARS.Content}</th>
            <td colSpan="2">
              {prepareNum(props.data.NumberOfRebars, true)}
            </td>
          </tr>
          <tr>
            <th scope="row">{APP_TEXTS.REBAR_DESIGN_TENSILE_CAPACITY.Content}</th>
            <td colSpan="2">
              {prepareNum(props.data.FRd, true)}
            </td>
          </tr>
          <tr>
            <th scope="row">{APP_TEXTS.REBAR_DESIGN_XNC.Content}</th>
            <td colSpan="2">
              {prepareNum(props.data.Xnc, true)}
            </td>
          </tr>
          <tr>
            <th scope="row">{APP_TEXTS.REBAR_DESIGN_K1.Content}</th>
            <td colSpan="2">
              {prepareNum(props.data.k1, true)}
            </td>
          </tr>
          <tr>
            <th scope="row">{APP_TEXTS.REBAR_DESIGN_K2.Content}</th>
            <td colSpan="2">
              {prepareNum(props.data.k2, true)}
            </td>
          </tr>
          <tr>
            <th scope="row">{APP_TEXTS.REBAR_DESIGN_K3.Content}</th>
            <td colSpan="2">
              {prepareNum(props.data.k3, true)}
            </td>
          </tr>
          </tbody>
        </Table>
      )}

      {!props.isAS3600 && props.data && (
        <div>
          <Table bordered size="sm">
            <tbody>
            <tr>
              <th scope="row">{APP_TEXTS.REBAR_DESIGN_ANCHORAGE_LBD.Content}</th>
              <td>
                {getValue(props.anchorageLbd, 'DISTANCE', props)}
              </td>
              <td>
                {unitLabel(props.currentUnits.DISTANCE)}
              </td>
            </tr>
            <tr>
              <th scope="row">{APP_TEXTS.REBAR_DESIGN_NUMBER_REBARS.Content}</th>
              <td>
                {prepareNum(props.data.NumberOfRebars, true)}
              </td>
              <td></td>
            </tr>
            <tr>
              <th scope="row">{APP_TEXTS.REBAR_DESIGN_ULTIMATE_LOAD.Content}</th>
              <td>
                {getValue(props.data.FRd, 'LOAD', props)}
              </td>
              <td>
                {unitLabel(props.currentUnits.LOAD)}
              </td>
            </tr>
            <tr>
              <th scope="row">{APP_TEXTS.REBAR_DESIGN_BOND_RESISTANCE.Content}</th>
              <td>
                {getValue(props.data.Fbd, 'STRENGTH', props)}
              </td>
              <td>
                {unitLabel(props.currentUnits.STRENGTH)}
              </td>
            </tr>
            <tr>
              <th scope="row">{APP_TEXTS.REBAR_DESIGN_FACTOR.Content}</th>
              <td>
                {prepareNum(props.data.alpha2Factor, true)}
              </td>
              <td></td>
            </tr>
            </tbody>
          </Table>

          {props.FireCalculation && (
            <Table bordered size="sm">
              <tbody>
              <tr>
                <th scope="row">{APP_TEXTS.REBAR_DESIGN_FIRE_DURATION.Content}</th>
                <td colSpan="2">
                  {prepareNum(props.fireDuration, true)}
                </td>
              </tr>
              <tr>
                <th scope="row">{APP_TEXTS.REBAR_DESIGN_ULTIMATE_LOAD_FIRE_RESISTANCE.Content}</th>
                <td colSpan="2">
                  {prepareNum(props.data.FRd_fi, true)}
                </td>
              </tr>
              <tr>
                <th scope="row">{APP_TEXTS.REBAR_DESIGN_ANCHORAGE_FIRE_RESISTANCE.Content}</th>
                <td colSpan="2">
                  {prepareNum(props.data.Lbd_fi, true)}
                </td>
              </tr>
              </tbody>
            </Table>
          )}
        </div>
      )}
    </section>
  </div>
);

function getValue(value, unitType, props) {
  if (Number.isFinite(+value)) {
    return unitTransform(+value).from(defaultUnits[unitType]).to(props.currentUnits[unitType]);
  } else {
    return value;
  }
}

const mapState = state => ({
  data: state.selectors.calculate[state.main.appType].gridSelectedItem || {},
  isAS3600: +state.main.localization.designStandard === +standardList['AS3600'],

  anchorageLbd: (() => {
    const item = state.selectors.calculate[state.main.appType].gridSelectedItem;
    let anchorageLbd = null;

    if (item && item.Status) {
      if (item.FireCalculation) {
        anchorageLbd = Math.max(item.Lbd, item.Lbd_fi);
      } else {
        anchorageLbd = item.Lbd;
      }
    }

    return anchorageLbd || '-';
  })(),
  fireDuration: state.selectors.design[state.main.appType].eurocodePlusFireMinute,
  currentUnits: {
    DISTANCE: state.main.units.distance,
    LOAD: state.main.units.load,
    STRENGTH: state.main.units.strength
  }
});

export default connect(mapState)(CalculateInstallationData);



// WEBPACK FOOTER //
// ./src/views/Calculate/components/RebarDesignCalculation/index.js